// import { io } from "socket.io-client";

// const baseurl = process.env.REACT_APP_API_BASE_URL;

// let socket = null;

// export const initializeSocket = (userId) => {
//   if (!socket) {
//     socket = io(baseurl, {
//       transports: ["websocket"],
//       query: { userId },
//     });

//     socket.on("connect", () => {
//       console.log("🔗 Socket Connected:", socket.id);
//       // localStorage.setItem('socketId', JSON.stringify(socket))
//     });

//     socket.on("disconnect", () => {
//       console.log("❌ Socket Disconnected");
//     });
//   }
//   return socket;
// };

// export const getSocket = () => {
//   if (!socket) {
//     console.warn(
//       "⚠️ Socket not initialized! Call initializeSocket(userId) first.",
//     );
//   }
//   return socket;
// };

// export const disconnectSocket = () => {
//   if (socket) {
//     socket.disconnect();
//     socket = null;
//     console.log("🔌 Socket disconnected manually");
//   }
// };

import { io } from "socket.io-client";

const baseurl = process.env.REACT_APP_API_BASE_URL;

let socket = null;

export const initializeSocket = (userId) => {
  if (!userId) {
    console.error("❌ Cannot initialize socket without userId");
    return null;
  }

  // If socket already exists and is connected, return it
  if (socket && socket.connected) {
    console.log("✅ Socket already connected:", socket.id);
    return socket;
  }

  console.log("🔌 Creating new socket connection for user:", userId);

  socket = io(baseurl, {
    transports: ["websocket"],
    query: { userId },
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
  });

  socket.on("connect", () => {
    console.log("🔗 Socket Connected:", socket.id);
    console.log("User ID:", userId);
  });

  socket.on("disconnect", (reason) => {
    console.log("❌ Socket Disconnected. Reason:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("❌ Socket Connection Error:", error.message);
  });

  socket.on("reconnect", (attemptNumber) => {
    console.log("🔄 Socket Reconnected after", attemptNumber, "attempts");
  });

  socket.on("reconnect_attempt", (attemptNumber) => {
    console.log("🔄 Reconnection attempt", attemptNumber);
  });

  // Test listener to verify socket is receiving events
  socket.onAny((eventName, ...args) => {
    console.log("📨 Socket received event:", eventName, args);
  });

  return socket;
};

export const getSocket = () => {
  if (!socket) {
    console.warn(
      "⚠️ Socket not initialized! Call initializeSocket(userId) first.",
    );
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    console.log("🔌 Disconnecting socket...");
    socket.disconnect();
    socket = null;
  }
};
